import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useMapsConfig = () => {
    const { i18n } = useTranslation()

    const mapsRegionConfig = useMemo(() => {
        const currentLang = i18n.language
        let region = 'KR'
        let language = currentLang

        switch (currentLang) {
            case 'ko':
                region = 'KR'
                break
            case 'en':
                region = 'US'
                break
            case 'ja':
                region = 'JP'
                break
            case 'cn':
                region = 'CN'
                language = 'zh-CN'
                break
            default:
                region = 'KR'
                break
        }

        return { region, language }
    }, [i18n.language])

    return mapsRegionConfig
}
